import axios from 'axios'

export default (baseURL, timeout) => {
  baseURL = baseURL || 'https://h5activity.kugou.com/musician/'
  var instance = axios.create({
    baseURL,
    timeout: timeout || 600000
  })

  instance.interceptors.response.use(function (response) {
    return response
  })
  return instance
}
